var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back"},[_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.$t('settings.settings')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }